import { BRAND } from "../lib/constants";
import { FlaskConical } from "lucide-react";

export const BookNowButton = ({
  variant = "primary",
  className = "",
  children,
  testId = "book-now-btn",
}) => {
  const base =
    "inline-flex items-center gap-2 rounded-full px-7 py-3 text-sm sm:text-base font-semibold transition-all duration-300 font-body tracking-tight whitespace-nowrap";
  const styles =
    variant === "primary"
      ? "bg-[#00E5FF] text-black hover:bg-white hover:shadow-[0_0_40px_rgba(0,229,255,0.45)]"
      : variant === "dark"
      ? "bg-black text-white border border-white/20 hover:border-[#00E5FF] hover:text-[#00E5FF]"
      : "bg-white text-black hover:bg-[#00E5FF]";
  return (
    <a
      href={BRAND.bookUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${base} ${styles} ${className}`}
    >
      {children || "Book Now"}
      <span aria-hidden className="text-lg leading-none">→</span>
    </a>
  );
};

export const LabChip = ({ children, testId }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.18em] text-white/70 font-body"
  >
    <FlaskConical size={12} className="text-[#00E5FF]" />
    {children}
  </span>
);

export const SectionHeader = ({ eyebrow, title, sub, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <LabChip>{eyebrow}</LabChip>}
    <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
      {title}
    </h2>
    {sub && (
      <p className="mt-6 text-base sm:text-lg text-white/60 font-body leading-relaxed max-w-2xl">
        {sub}
      </p>
    )}
  </div>
);
